import { h } from "preact";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { classNames } from "../helpers";

import i18n from "../i18n";
import { setTaskFilter } from "../store";
import Avatar from "./Avatar.jsx";
import Tag from "./Tag.jsx";
import TaskProgress from "./TaskProgress.jsx";

export default function TaskListItem({ noLink, user, task }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleClick(event) {
    if (noLink) {
      return;
    }

    event.preventDefault();
    navigate(`/tasks/${encodeURIComponent(task.id)}`);
  }

  function handleTaskLabelClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    dispatch(setTaskFilter(task.objective));
  }

  return (
    <div
      class={classNames(
        "task-list__item row",
        noLink && "task-list__item--noLink"
      )}
      onClick={handleClick}
      role="listitem"
    >
      <div class="col s2 l1 state-col">
        <TaskProgress task={task} />
      </div>
      <div class="col s5 hide-on-med-and-down" role="heading" aria-level="3">
        {i18n.t(`tasks.${task.id}.title`)}
      </div>
      <div class="col s4 hide-on-med-and-down">
        <Avatar user={user} small plain class="mr-8" />
        <Tag noHover class="ml-0 mb-0" onClick={handleTaskLabelClick}>
          {task.objective}
        </Tag>
      </div>
      <div class="hide-on-large-only col s10">
        <h3 class="task-list__item__title t-body3">
          {i18n.t(`tasks.${task.id}.title`)}
        </h3>
        <div class="task-list__item__objective">
          <Tag noHover class="ml-0 mb-0" onClick={handleTaskLabelClick}>
            {task.objective}
          </Tag>
        </div>
      </div>
      <div class="col s2 t-caption task-list__item__timeeffort">
        {i18n.t(`tasks.${task.id}.approx_duration`)}
      </div>
    </div>
  );
}
